<template>
    <div>
        <div v-if="isAppIdle"></div>

        <div v-if="!loading">
            <div class="overview-content-frame content">
                <img class="pl-5 ml-2" v-if="enrollment.course.logo" :src="enrollment.course.logo" style="height: 70px;"/>

                <div class="ml-4 pl-4 mb-6 mt-5">
                    <i class="far fa-info-circle mr-2"></i>Section Overview
                    <h2 class="mt-2 has-text-grey-dark">{{ section.title }}</h2>
                </div>

                <div class="objective">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fad fa-bullseye-pointer fa-2x"></i></div>
                        <div class="column">
                            <h4 class="mt-1">Learning Objective</h4>
                            {{ section.description }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-controls">
                <div class="columns">
                    <div class="column">

                    </div>
                    <div class="column has-text-right">
                        <b-button type="is-white" outlined class="ml-5" @click="goToNext()">Start Section<i class="fas fa-arrow-right ml-3"></i></b-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="overview-content-frame content pl-5 pt-6" v-else>
            <h4 class="has-text-grey"><i class="fas fa-spinner fa-spin mr-4"></i>Please wait. Loading content...</h4>
        </div>
    </div>
</template>

<script>
    import async from "async";

    import {client as http} from "@/http_client";


    export default {
        props: ['enrollmentId', 'sectionId'],
        data: function() {
            return {
                loading: true,
                enrollment: {
                    data: {}
                },
                nextOutlineId: null,
                section: null
            };
        },
        methods: {
            loadByOutline: function() {
                this.loading = true;

                async.series([
                    (cb) => {
                        http.get('app/enrollments/' + this.enrollmentId, {force: true}).then(response => {
                            this.enrollment = response.data;

                            for (let i = 0; i < this.enrollment.course.outline.length; i++) {
                                let section = this.enrollment.course.outline[i];

                                if (section.type_id === parseInt(this.sectionId)) {
                                    this.section = section;
                                    // if (section.components[0].completed_at) {
                                        this.nextOutlineId = section.components[0].component_id;
                                    // }
                                    break;
                                }
                            }

                            cb();
                        }).catch(err => {
                            console.log('Enrollment loading failed.');
                            cb(err);
                        });
                    },
                ], (err) => {
                    if (err) console.log(err);

                    this.loading = false;
                });
            },

            goToNext: function() {
                // if (this.nextOutlineId) {
                    this.$router.push({name: 'component', params: {enrollmentId: this.enrollmentId, outlineId: this.nextOutlineId}});
                // } else {
                //     window.alert('You are not ready to start this section.  Complete previous content first.');
                // }
            }
        },
        watch: {
            'sectionId': function() {
                // this doesn't have to reload everything... just look for the proper section instead
                this.loadByOutline();
            }
        },
        mounted: function() {
            this.loadByOutline();
        },
        destroyed: function() {
            if (this.timer) clearInterval(this.timer);
        },
        onIdle() {
            console.log('IDLE');
            this.timeout = 60;
        },
        onActive() {
            console.log('ACTIVE');
            // this.sendPing();
        }
    };
</script>

<style lang="scss" scoped>
    .overview-content-frame {
        position: absolute;
        top: var(--course-frame-top);
        left: var(--course-frame-left);
        right: var(--course-frame-right);
        bottom: var(--course-frame-bottom);
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
        padding: var(--course-frame-pad) var(--course-frame-pad) 7rem;

        overflow-x: hidden;
        overflow-y: auto;
    }

    .content-controls {
        position: absolute;
        left: var(--course-frame-left);
        right: var(--course-frame-right);
        bottom: var(--course-controls-bottom);
        padding: var(--course-controls-pad-top) 0 1rem;
        font-size: 0.85rem;

        color: white;

        strong {
            color: white;
        }
    }

    .objective {
        background-color: #f4f4f4;
        padding: 2rem;
        margin: 2rem;
        border-radius: 1rem;
    }

</style>
